import { ownershipOf } from '../lib/ownership';

/**
 * "Who is talking to this customer" as a labelled chip. (E5 / T040.)
 *
 * Always carries the word, never colour alone — see lib/ownership.js for why
 * that matters, and why this must stay visually distinct from the
 * needs-attention indicator.
 *
 * `compact` drops to the short label for the kanban card, where the chip sits
 * beside four others and every character costs width. The full label is still
 * in the tooltip and in the aria-label, so the meaning is never only in an
 * abbreviation.
 */
export default function OwnershipChip({ lead, compact = false, showDot = true }) {
  const o = ownershipOf(lead);
  return (
    <span
      className="lc-chip"
      title={o.long}
      aria-label={o.long}
      style={{
        background: o.tint,
        color: o.color,
        borderColor: 'transparent',
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
        fontWeight: 500,
      }}
    >
      {showDot && (
        <span
          aria-hidden="true"
          style={{ width: 6, height: 6, borderRadius: '50%', background: o.color, flexShrink: 0 }}
        />
      )}
      {compact ? o.label : o.long}
    </span>
  );
}
